import React, { useEffect, useState } from "react";
import { Heart, RefreshCw, ShoppingCart, CreditCard } from "lucide-react";
import "./Single_product_card.css";
import { useNavigate } from "react-router-dom";


function SingleProductCard({ product, setShowMessage, setMessageContent }) {
  const navigate = useNavigate();
  const [stock, setStock] = useState(0);
  const [loading, setLoading] = useState(false);

  async function stockCheck() {
    try {
      const response = await fetch(
        "https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/stock-details", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          "sku": product?.Model
        })
      });
      const data = await response?.json();
      console.log("in stock data", data);
      //console.log("in stock quantity",data?.body?.ProductStock[0]?.Available_Qty);
      return data?.body?.ProductStock[0]?.Available_Qty;
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    const fetchStock = async () => {
      setLoading(true);
      const stock = await stockCheck();
      setStock(stock);
      setLoading(false);
    }
    fetchStock();
  }, [])
  function handleAddToCart() {
    const cart = JSON.parse(localStorage.getItem('cart')) || [];
    const existingItemIndex = cart.findIndex(item => item.model === product.Model);
    if (existingItemIndex !== -1) {
      cart[existingItemIndex].quantity += 1;
    } else {
      cart.push({
        model: product?.Model,
        name: product?.Name,
        price: product?.Sale_price || product?.Regular_price,
        url: `https://khoslaslider.s3.ap-south-1.amazonaws.com${product?.Images?.split(',')[0]}`,
        quantity: 1
      });
    }
    localStorage.setItem('cart', JSON.stringify(cart));
    setShowMessage(true);
    setMessageContent(`${product.Name} added to cart successfully`);
    setTimeout(() => {
      setShowMessage(false);
      setMessageContent("");
    }, 5000)
  }

  if (loading) return <div></div>;
  function handleCompare() {
    const existingCompareItems = JSON.parse(localStorage.getItem('compareItems')) || [];
    const isProductExists = existingCompareItems.findIndex(
      item => item.model?.toLowerCase() === product?.Model?.toLowerCase()
    );
    if (isProductExists !== -1) {
      return;
    }
    const productToCompare = {
      sale_price: product?.Sale_price || null,
      regular_price: product?.Regular_price || null,
      description: product?.Short_description || null,
      stock: product?.In_stock || null,
      weight: product?.Weight || null,
      brand: product?.Brands || null,
      image: `https://khoslaslider.s3.ap-south-1.amazonaws.com${product?.Images?.split(',')[0]}` || null,
      name: product?.Name || null,
      model: product?.Model || null,
      dimmensions: product?.Dimensions || null,
      sku: product?.sku || null,
      catagory: product?.Categories.split(",").flatMap(item => item.split(">")).map(item => item.trim())[0] || null
    };

    const updatedCompareItems = [...existingCompareItems, productToCompare];

    localStorage.setItem('compareItems', JSON.stringify(updatedCompareItems));
  };

  function handleWishlistAdd() {
    const existingWishlistItems = JSON.parse(localStorage.getItem('wishlist')) || [];
    const isProductExists = existingWishlistItems.findIndex(
      item => item.model?.toLowerCase() === product?.Model?.toLowerCase()
    );
    if (isProductExists !== -1) {
      return;
    }
    const productToWishlist = {
      sale_price: product?.Sale_price || null,
      regular_price: product?.Regular_price || null,
      name: product?.Name || null,
      model: product?.Model || null,
      image: `https://khoslaslider.s3.ap-south-1.amazonaws.com${product?.Images?.split(',')[0]}` || null,
    }
    const updatedWishlistItems = [...existingWishlistItems, productToWishlist];
    localStorage.setItem('wishlist', JSON.stringify(updatedWishlistItems));

  }
  return (

    <div className="single_product_card_main-container">
      <div className="single_product_card_discount">
        {(product.Sale_price) ? Math.floor(((product.Regular_price - product.Sale_price) / product.Regular_price) * 100) : 0} % off
      </div>
      <h4 className="single_product_card_title" onClick={() => window.open(`/product/${product.Model.split('/')[0]}`, '_blank', 'noopener,noreferrer')}>{product.Name}</h4>

      <img src={product.Images ? `https://khoslaslider.s3.ap-south-1.amazonaws.com${product.Images.split(',')[0]}` : ''} className="single_product_card_image" onClick={() => window.open(`/product/${product.Model.split('/')[0]}`, '_blank', 'noopener,noreferrer')} />

      {/* <p>
        MRP <span className="single_product_card_mrp">{product.Sale_price ? `₹${Number(product.Regular_price).toLocaleString('en-IN', {maximumFractionDigits: 2,minimumFractionDigits: 2})}` : ''}</span>
      </p> */}

      <p>
        MRP <span className="single_product_card_mrp">{`₹${Number(product.Regular_price).toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`}</span>
      </p>

      <div className="single_product_card_price-cart-container">
        <div className="single_product_card_price">
          <h2>₹{product.Sale_price ? Number(product.Sale_price).toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 }) : Number(product.Regular_price).toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</h2>
          <p className="single_product_card_tax">(inclusive of all taxes)</p>
        </div>

        {stock > 2 &&
          <ShoppingCart className="single_product_card_cart-icon" size={25} onClick={handleAddToCart} />
        }
      </div>

      <div className="single_product_card_action-container">
        <div className="single_product_card_buy-now-container" onClick={() => window.open(`/product/${product.Model.split('/')[0]}`, '_blank', 'noopener,noreferrer')}>
          <CreditCard size={20} color={'#FF0000'} style={{ marginRight: '-12%' }} className="single_product_card_buy-now-icon" />
          <button className="single_product_card_buy-now-button">{stock > 2 ? 'Buy Now' : 'Out of Stock'}</button>
        </div>

        <div>
          <Heart className="single_product_card_wish-compare-icon" size={20} onClick={handleWishlistAdd} />
          <RefreshCw className="single_product_card_wish-compare-icon" size={20} onClick={handleCompare} />
        </div>
      </div>
    </div>

  );
};

export default SingleProductCard;
